import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
const paths = [
    'M3.99181 7.55915C3.83621 7.55915 3.6806 7.68882 3.6806 7.87036L3.6806 8.1297C3.6806 8.2853 3.83621 8.44091 3.99181 8.44091L12.0082 8.44084C12.1638 8.44084 12.3195 8.28524 12.3195 8.12963L12.3195 7.87029C12.3195 7.68875 12.1638 7.55908 12.0082 7.55908L3.99181 7.55915Z',
];
export const Minus = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0 0 16 16" }, props, { children: paths.map((pathString, i) => (_jsx("path", { d: pathString }, i))) })));
Minus.iconCategory = 'ui';
